var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.51,
    y: 281.47,
    width: 18.6,
    height: 97.26,
    transform: "translate(311.62 660.19) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.44,
    y: 378.73,
    width: 81.1,
    height: 3.66,
    transform: "translate(241.99 761.11) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.87,
    y: 281.47,
    width: 69.64,
    height: 97.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,313.41v29.34H80V313.41h63.46m.45-.45H79.51V343.2h64.36V313Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,328.11a2.74,2.74,0,1,1-2.74-2.74A2.74,2.74,0,0,1,114.43,328.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.51,
    y: 284.67,
    width: 64.36,
    height: 22.31,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.51,
    y: 349.18,
    width: 64.36,
    height: 22.31,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.51,
    y: 284.67,
    width: 13.58,
    height: 22.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.51,
    y: 349.18,
    width: 13.58,
    height: 22.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,380.3h0A11.29,11.29,0,0,0,241.14,369V272.51a11.28,11.28,0,0,0-11.26-11.26H168.59V380.3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,261.25h0a11.29,11.29,0,0,0-11.26,11.26v94a13.79,13.79,0,0,0,13.79,13.79h8.73V272.51A11.29,11.29,0,0,0,168.59,261.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.87,303.71l4-49.22A14.76,14.76,0,0,0,404,238.29H260.82a17.93,17.93,0,0,0-17.5,16.2l-4,49.22a10,10,0,0,0,10.05,10.94H403.05A12.1,12.1,0,0,0,414.87,303.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,303.71l4-49.22A14.76,14.76,0,0,0,384,238.29H240.81a17.93,17.93,0,0,0-17.5,16.2l-4,49.22a10,10,0,0,0,10,10.94H383.05A12.1,12.1,0,0,0,394.86,303.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.35,268.36s-2.94-2.21-1.88-3.39,5.89,1.06,5.89,1.06,27.2-3.42,43.2-2.81c.11-2.15,2.24-3,4-2.6s0,3.9,0,3.9,11.22,28.6,10.86,43c1.8,1.54,3.58,2.63,1.75,3.37a3.72,3.72,0,0,1-3.47-.63s-36.11,5.28-50.8,2.61c-1,2-3.11,1.58-4.32,1s.81-3.44.81-3.44S196.35,285.45,199.35,268.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.08,380.3h0A11.3,11.3,0,0,0,433.34,369V272.51a11.29,11.29,0,0,0-11.26-11.26H368.81V380.3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.44,
    y: 229.04,
    width: 22.52,
    height: 183.47,
    rx: 6.4,
    transform: "translate(600.47 41.08) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.54,
    y: 268.4,
    width: 48.26,
    height: 175.53,
    rx: 3.42,
    transform: "translate(639.83 72.5) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81,261.25h0a11.29,11.29,0,0,0-11.26,11.26V380.3h22.52V272.51A11.29,11.29,0,0,0,368.81,261.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.86,382.38H176.68a2.08,2.08,0,0,1-2.08-2.08H420A2.09,2.09,0,0,1,417.86,382.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.27,
    y: 84.74,
    width: 234.33,
    height: 130.46,
    transform: "translate(512.87 299.94) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.4,
    y: 84.74,
    width: 246.02,
    height: 130.46,
    transform: "translate(498.82 299.94) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.2,
    y: 30.98,
    width: 122.42,
    height: 237.98,
    transform: "translate(399.38 -99.44) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41,109.33h76.72a81.28,81.28,0,0,1,81.28,81.28H251.69A81.28,81.28,0,0,1,170.41,109.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.91,198.19H251.69a81.86,81.86,0,0,1-81.78-81.77v-.5h77.22a81.87,81.87,0,0,1,81.78,81.77Zm-158-81.27a80.86,80.86,0,0,0,80.78,80.27h76.22a80.86,80.86,0,0,0-80.78-80.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.91,184H251.69a81.86,81.86,0,0,1-81.78-81.77v-.5h77.22a81.87,81.87,0,0,1,81.78,81.77Zm-158-81.27A80.86,80.86,0,0,0,251.69,183h76.22a80.86,80.86,0,0,0-80.78-80.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-18",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.79,
    y: 132.89,
    width: 327.79,
    height: 217.2,
    rx: 6.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.86 409.36 245.21 409.36 232.49 280.44 306.14 280.44 318.86 409.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.89 409.36 243.24 409.36 230.51 280.44 304.16 280.44 316.89 409.36",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.26,413.7H239l1-4.34h89.83a3.52,3.52,0,0,1,3.42,4.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.16,
    y1: 413.7,
    x2: 325.13,
    y2: 409.36,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.28,413.7H223a5.65,5.65,0,0,1,5.5-4.34h89.82Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.13,409.36H315.7a3.52,3.52,0,0,0-3.43,4.34h13.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.16 280.43 230.51 280.43 238 356.26 311.65 356.26 304.16 280.43",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.98,
    y: 132.89,
    width: 327.79,
    height: 217.2,
    rx: 6.17,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.88,
    cy: 335.23,
    r: 5.8,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.61,
    y: 145.65,
    width: 322.31,
    height: 173.29,
    rx: 2.62,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.21,283a57.76,57.76,0,0,1-21.7-6.64,55.44,55.44,0,0,1-16.77-13.93,53.12,53.12,0,0,1-9.65-18.54,50.79,50.79,0,0,1-2-14h10.47l-20.35-35.25-20.35,35.25h10.93a68.52,68.52,0,0,0,6.7,20,66.56,66.56,0,0,0,16.34,20.38A64.32,64.32,0,0,0,257,282.35a62.08,62.08,0,0,0,24.19,2.5,1,1,0,0,0,.85-.85A.94.94,0,0,0,281.21,283Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,234.65a68.54,68.54,0,0,0-6.71-20,66.68,66.68,0,0,0-16.34-20.38,64.29,64.29,0,0,0-22.16-12.06,62.09,62.09,0,0,0-24.19-2.51,1,1,0,0,0-.85.85.94.94,0,0,0,.85,1,57.94,57.94,0,0,1,21.7,6.64A55.59,55.59,0,0,1,303,202.14a53.12,53.12,0,0,1,9.65,18.54,50.79,50.79,0,0,1,2,14H304.16l20.35,35.25,20.36-35.25Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "178.3 211.47 222.61 145.62 166.95 145.62 123.49 210.18 121.65 212.93 111.72 227.69 111.72 310.41 121.65 295.65 178.3 211.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.19 145.62 218.79 229.43 161.77 314.16 158.57 318.91 185.84 318.91 218.79 269.97 302.46 145.62 275.19 145.62",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smartphone--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.8,
    y: 197.44,
    width: 107.23,
    height: 217.2,
    rx: 10.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.86,
    y: 235.61,
    width: 5.53,
    height: 30.41,
    rx: 2.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.42,
    y: 235.61,
    width: 5.53,
    height: 14.85,
    rx: 1.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.42,
    y: 255.24,
    width: 5.53,
    height: 14.85,
    rx: 1.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.99,
    y: 197.44,
    width: 107.23,
    height: 217.2,
    rx: 10.86,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.47,
    y: 210.18,
    width: 104.27,
    height: 192.09,
    rx: 2.62,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82,328.89a29.21,29.21,0,0,1-11-3.36,27.87,27.87,0,0,1-8.47-7,26.81,26.81,0,0,1-4.87-9.36,26,26,0,0,1-1-7.06h5.29L90.54,284.29,80.26,302.08h5.52a34.72,34.72,0,0,0,3.38,10.11,33.68,33.68,0,0,0,8.26,10.29,32.61,32.61,0,0,0,11.18,6.09,31.29,31.29,0,0,0,12.22,1.26.47.47,0,0,0,.42-.43A.46.46,0,0,0,120.82,328.89Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.43,304.49a34.37,34.37,0,0,0-3.38-10.1,33.68,33.68,0,0,0-8.25-10.29A32.32,32.32,0,0,0,124.61,278a31.27,31.27,0,0,0-12.21-1.27.49.49,0,0,0-.43.43.48.48,0,0,0,.43.52A29.2,29.2,0,0,1,123.35,281a28,28,0,0,1,8.47,7,26.78,26.78,0,0,1,4.87,9.37,25.82,25.82,0,0,1,1,7.05H132.4l10.28,17.8L153,304.49Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.37,211.47a2.6,2.6,0,0,0-2.25-1.29H113.57l-1.85,2.75L64.47,283.14v82.73l47.25-70.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.72,314.16,64.47,384.37v15.28a2.62,2.62,0,0,0,2.62,2.62H79.7l56.1-83.36L168.74,270V229.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.3,202.46h20.62a1.35,1.35,0,0,1,1.34,1.34h0a1.35,1.35,0,0,1-1.34,1.34H106.3A1.34,1.34,0,0,1,105,203.8h0A1.35,1.35,0,0,1,106.3,202.46Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.86,70.3a13.36,13.36,0,0,0-12.71,9.4c-.41-.06-.83-.1-1.26-.13l-8.68,30a15.58,15.58,0,0,0,7.66,2h7.23l11.76-40.59A12.88,12.88,0,0,0,359.86,70.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83,76.88a12.28,12.28,0,0,0-4.13.72,13.42,13.42,0,0,0-5.62-5.74l-11.49,39.66H367l10-34.58A11.12,11.12,0,0,0,375.83,76.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324,98.62a1,1,0,0,1-.71-1.7,1,1,0,0,1,1.42,0,1,1,0,0,1-.71,1.7Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.78,187.81a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,187.81Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,183.79Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,179.77Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,175.74Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,171.72Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,167.7Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,163.68Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,159.66Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,155.64Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,151.62Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,147.6Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,143.58Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,139.56Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,135.54Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,131.52Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,127.5Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,123.48Zm0-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,83.78,119.46Zm1-3a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0Zm.29-4a1,1,0,0,1-.74-1.21h0a1,1,0,0,1,1.21-.73h0a1,1,0,0,1,.74,1.2h0a1,1,0,0,1-1,.77h0A1,1,0,0,1,85.05,112.43Zm1.16-3.85a1,1,0,0,1-.45-1.34h0a1,1,0,0,1,1.34-.45h0a1,1,0,0,1,.45,1.34h0a1,1,0,0,1-.89.56h0A1.06,1.06,0,0,1,86.21,108.58Zm2-3.49a1,1,0,0,1-.15-1.4h0a1,1,0,0,1,1.41-.15h0a1,1,0,0,1,.15,1.41h0a1,1,0,0,1-.78.37h0A1,1,0,0,1,88.2,105.09Zm2.7-3a1,1,0,0,1,.17-1.4h0a1,1,0,0,1,1.4.16h0a1,1,0,0,1-.16,1.41h0a1.05,1.05,0,0,1-.62.21h0A1,1,0,0,1,90.9,102.12Zm3.29-2.31a1,1,0,0,1,.47-1.33h0A1,1,0,0,1,96,99h0a1,1,0,0,1-.48,1.33h0a.91.91,0,0,1-.43.1h0A1,1,0,0,1,94.19,99.81Zm3.72-1.52a1,1,0,0,1,.75-1.2h0a1,1,0,0,1,1.2.76h0A1,1,0,0,1,99.1,99h0a.78.78,0,0,1-.22,0h0A1,1,0,0,1,97.91,98.29ZM319,97.62a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,319,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,315,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,310.94,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,306.92,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,302.9,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,298.88,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,294.86,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,290.84,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,286.82,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,282.79,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,278.77,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,274.75,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,270.73,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,266.71,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,262.69,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,258.67,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,254.65,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,250.63,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,246.61,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,242.59,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,238.57,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,234.55,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,230.53,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,226.51,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,222.49,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,218.47,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,214.45,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,210.42,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,206.4,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,202.38,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,198.36,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,194.34,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,190.32,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,186.3,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,182.28,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,178.26,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,174.24,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,170.22,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,166.2,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,162.18,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,158.16,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,154.14,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,150.12,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,146.1,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,142.08,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,138.06,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,134,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,130,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,126,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,122,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,118,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,113.93,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,109.91,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,105.89,97.62Zm-4,0a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,101.87,97.63Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,192.85a1,1,0,0,1-.71-.3,1,1,0,0,1-.29-.7,1,1,0,0,1,.29-.71,1,1,0,0,1,1.42,0,1,1,0,0,1,.29.71,1,1,0,0,1-1,1Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.58,128.85a1,1,0,0,1-1-1,1,1,0,0,1,.3-.71,1,1,0,0,1,1.41,0,1,1,0,0,1,.29.71,1,1,0,0,1-.29.7A1,1,0,0,1,365.58,128.85Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,124a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,364.58,124Zm0-3.81a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h0A1,1,0,0,1,364.58,120.22Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.58,117.4a1,1,0,0,1-.7-.29,1,1,0,0,1-.3-.71,1,1,0,0,1,.3-.7,1,1,0,0,1,1.41,0,1,1,0,0,1,.29.7,1,1,0,0,1-.29.71A1,1,0,0,1,365.58,117.4Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,79.59l-.2,0-.57,0h-5.84q.5,0,1,0l.21,0a9.91,9.91,0,0,1,1.08.12h5.42l-.19,0C352.08,79.64,351.79,79.61,351.48,79.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.8,100.88c0-.35.05-.71.05-1.08v-.25c0-.29,0-.58-.06-.86a1.23,1.23,0,0,0,0-.19c0-.15,0-.29,0-.44s0-.22-.06-.33-.05-.28-.08-.41-.1-.45-.16-.67-.07-.24-.11-.36l0-.13c-.09-.26-.18-.52-.29-.78l-.07-.16c-.11-.26-.22-.52-.35-.77a1.74,1.74,0,0,1-.1-.19c-.15-.28-.31-.56-.49-.83,0-.05-.07-.1-.1-.16-.16-.23-.32-.45-.49-.67l-.12-.17q-.3-.37-.63-.72a1.85,1.85,0,0,1-.14-.14c-.1-.1-.19-.2-.29-.29l-.23-.2-.34-.3-.47-.37-.36-.26-.15-.11c-.2-.14-.41-.27-.63-.4h0c-.2-.11-.41-.23-.62-.33l-.15-.07c-.25-.12-.5-.22-.76-.32l-.28-.12-.08,0c-.26-.09-.51-.16-.77-.23l-.31-.1h0c-.36-.08-.73-.15-1.1-.21h0c-.38,0-.77-.08-1.15-.1l-.06-.41c0-.14-.05-.28-.08-.43s-.05-.31-.09-.46-.11-.44-.17-.66-.07-.28-.12-.42,0-.07,0-.11c-.1-.28-.2-.56-.31-.83,0-.07-.06-.13-.08-.19-.11-.26-.23-.51-.36-.76l-.12-.24a9.34,9.34,0,0,0-.5-.87.35.35,0,0,1-.05-.08c-.17-.26-.35-.51-.53-.75l-.17-.22c-.18-.23-.38-.47-.58-.69l-.07-.08c-.18-.2-.37-.39-.57-.58l-.11-.1-.38-.33c-.15-.13-.3-.26-.46-.38l-.41-.3-.32-.23-.21-.13-.23-.15c-.25-.15-.51-.3-.77-.43l-.12-.07,0,0-.18-.08c-.32-.15-.64-.29-1-.41l-.13-.06-.31-.1-.74-.22-.21-.07-.28,0-.72-.14-.29,0-.22,0-.81-.07-.33,0h-4.86l-.12-.19c-.05-.1-.12-.18-.17-.28l-.42-.6-.21-.29-.48-.58-.19-.23c-.23-.26-.47-.5-.72-.74l0,0-.1-.08c-.21-.21-.44-.4-.67-.59l-.26-.21-.58-.42-.16-.12-.17-.11-.34-.21-.42-.24-.35-.19-.2-.1a.52.52,0,0,0-.13-.06,12.78,12.78,0,0,0-1.2-.52h0l-.1,0c-.35-.13-.71-.23-1.07-.33l-.16,0-.13,0a11.57,11.57,0,0,0-1.2-.23h0l-.79-.08h-.22l-.44,0h-5.77c.27,0,.53,0,.8,0h.21c.28,0,.56,0,.83.09a11.57,11.57,0,0,1,1.2.23l.29.07c.36.1.72.2,1.07.33l.13,0a12.78,12.78,0,0,1,1.2.52l.33.16.36.19.41.24.34.22.33.22.58.43.27.2c.23.19.45.39.67.59l.11.1c.25.24.49.48.72.74l.19.23c.17.19.33.38.48.58l.21.29c.15.2.28.4.42.6s.12.18.17.28a10.19,10.19,0,0,1,.52.91h5.42c-.12-.23-.24-.45-.37-.67l.55,0,.51.07.72.14.5.12.73.22.44.16c.33.12.65.26,1,.41l.22.1.13.07c.26.13.51.28.76.43l.23.15c.19.11.36.24.53.36l.41.3c.16.12.31.25.46.38l.38.33c.24.22.47.45.68.68L385,81c.21.22.4.46.59.69l.16.22c.19.24.36.49.53.75a.35.35,0,0,1,.05.08q.27.42.51.87l.12.24c.12.25.24.5.35.76,0,.06,0,.12.08.19.12.3.24.62.34.94,0,.14.07.28.11.42s.12.44.17.66.06.31.09.46.11.56.14.84c.39,0,.77.05,1.15.1h.05c.37.06.74.13,1.1.21l.35.11c.26.07.52.14.77.23s.24.1.36.15.51.2.76.32.52.26.77.4h0q.4.24.78.51c.13.08.24.17.36.26l.48.37.34.3c.17.16.35.32.51.49l.14.14q.33.35.63.72l.12.17c.17.22.34.44.49.67a.91.91,0,0,0,.11.16c.17.27.33.55.48.83a1.74,1.74,0,0,1,.1.19c.13.25.25.51.36.77a.77.77,0,0,0,.07.16c.12.3.22.6.32.91,0,.12.06.24.1.36s.11.44.16.67.06.27.08.41a6.49,6.49,0,0,1,.11.77l0,.19c0,.37.05.74.05,1.11a10.74,10.74,0,0,1-.06,1.14c0,.27-.07.54-.11.8s0,.27-.06.39c-.08.4-.18.78-.29,1.16,0,0,0,0,0,0-.12.37-.26.73-.41,1.09,0,.09-.08.18-.13.27-.13.3-.28.6-.44.89s-.25.42-.38.63l-.12.18c-.19.29-.39.56-.6.82l-.1.12a9.59,9.59,0,0,1-.68.75h0q-.36.36-.75.69l-.12.1c-.25.2-.51.4-.77.58l-.15.11c-.27.18-.55.35-.83.51l-.13.07c-.31.16-.61.31-.93.45h0c-.32.14-.64.25-1,.36l-.15.05c-.31.1-.64.18-1,.25l-.19,0c-.33.06-.66.12-1,.15l-.15,0c-.36,0-.72,0-1.09,0h5.42c.37,0,.73,0,1.09,0l.15,0c.34,0,.67-.09,1-.15l.19,0c.32-.07.65-.15,1-.25l.15-.05c.33-.11.65-.22,1-.36h0c.32-.14.62-.29.92-.45l.13-.07q.44-.24.84-.51l.15-.11c.26-.18.52-.38.77-.58l.12-.1q.39-.33.75-.69h0c.24-.24.46-.49.68-.75l.1-.12.06-.07q.29-.36.54-.75l.12-.18c.1-.16.21-.32.3-.49s.05-.1.08-.14c.16-.29.3-.59.44-.89a1.51,1.51,0,0,0,.11-.22s0,0,0,0a11,11,0,0,0,.4-1.09s0,0,0,0h0c.11-.38.21-.76.29-1.16v0c0-.12,0-.25.06-.37s.09-.53.11-.8C404.79,100.92,404.8,100.9,404.8,100.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.86,70.3a13.32,13.32,0,0,1,11.84,7.3,12.28,12.28,0,0,1,4.13-.72A12.61,12.61,0,0,1,388.28,88.1a11.72,11.72,0,0,1-.43,23.42h-43a16,16,0,0,1,0-32,14.32,14.32,0,0,1,2.28.17A13.36,13.36,0,0,1,359.86,70.3Z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.67 211.05 350.98 212.69 353.04 218.5 356.5 216.56 354.67 211.05",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.78,229.92l15.08-1.61a1.21,1.21,0,0,0,1.07-1.51l-5.49-24.45a1.6,1.6,0,0,0-1.68-1.22l-15.08,1.62a1.21,1.21,0,0,0-1.07,1.51l5.49,24.45A1.59,1.59,0,0,0,356.78,229.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,229.9l15.08-1.62a1.21,1.21,0,0,0,1.07-1.5l-5.49-24.46a1.59,1.59,0,0,0-1.68-1.21l-15.08,1.61a1.21,1.21,0,0,0-1.07,1.51l5.49,24.46A1.6,1.6,0,0,0,357,229.9Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,228.44l16.8-1.8a.29.29,0,0,0,.26-.36l-5.25-23.38a.38.38,0,0,0-.41-.29l-16.79,1.8a.29.29,0,0,0-.26.36l5.25,23.38A.38.38,0,0,0,355.8,228.44Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.67,218.3a4,4,0,0,1-1.48-.27,4.29,4.29,0,0,1-1.27-.76,4.07,4.07,0,0,1-.88-1.11,3.15,3.15,0,0,1-.32-.87l.67-.07-1.8-2.08-.81,2.36.7-.07a5,5,0,0,0,3.64,3,4,4,0,0,0,1.58,0,0,0,0,0,0,0-.06A.07.07,0,0,0,362.67,218.3Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,214.89a4.92,4.92,0,0,0-2.05-2.39,4.58,4.58,0,0,0-1.58-.61,4,4,0,0,0-1.59,0s0,0,0,0a.07.07,0,0,0,.07.06,4.13,4.13,0,0,1,1.48.27,4.32,4.32,0,0,1,1.27.77,3.81,3.81,0,0,1,.88,1.1,3.87,3.87,0,0,1,.33.87l-.67.08,1.8,2.08.8-2.36Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.31,204l-1.47,12.78h0l2.56,11.37a.38.38,0,0,0,.4.29l1.9-.2,2.86-24.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.19 203.15 359.33 228.06 362.66 227.7 365.92 202.75 362.19 203.15",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.9,202.41l-2.62.28a.15.15,0,0,0-.13.18h0a.2.2,0,0,0,.21.15l2.61-.28a.15.15,0,0,0,.13-.19h0A.19.19,0,0,0,359.9,202.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.82,210.06c2.2,3.64,4.19,7.28,6.1,11.05s3.65,7.6,5.21,11.62c.37,1,.76,2,1.09,3.09l.26.78.13.4.09.31.11.43a6.08,6.08,0,0,1,.05,2.49,5.19,5.19,0,0,1-1.7,2.9,5.62,5.62,0,0,1-2.13,1.13,7.65,7.65,0,0,1-1.52.27,12.23,12.23,0,0,1-2.23-.06,21.72,21.72,0,0,1-3.53-.74,58.25,58.25,0,0,1-11.91-5l1.63-4.19c3.94.83,8,1.73,11.72,2.2a20.5,20.5,0,0,0,2.59.16,3.77,3.77,0,0,0,.85-.1c.06,0,.1-.05,0,0a1.89,1.89,0,0,0-.77.41,3,3,0,0,0-1,1.59,2.38,2.38,0,0,0,0,1v.09l0-.09-.14-.33-.27-.67c-.35-.88-.78-1.78-1.16-2.67-1.65-3.58-3.5-7.15-5.41-10.71s-3.9-7.13-5.87-10.6Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,234.23l-4.13-1.59-1,6.85s3.28.87,5.55-.94Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.98 230.79 390.26 236.94 394.87 239.49 395.89 232.64 389.98 230.79",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88,188c.12.47,0,.91-.34,1s-.65-.24-.77-.71,0-.91.34-1S376.76,187.5,376.88,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.89,188.87a17.36,17.36,0,0,1-1.22,4.58,2.81,2.81,0,0,0,2.35-.15Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.94,184.93a.29.29,0,0,0,.14-.15.29.29,0,0,0-.16-.37,2.82,2.82,0,0,0-2.59.21.28.28,0,0,0-.06.39.28.28,0,0,0,.39.07h0a2.23,2.23,0,0,1,2-.14A.26.26,0,0,0,377.94,184.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.3,190.5c1.22,4.46.69,10.73,4.33,13.65,0,0-.32,4.45-8.47,4.45-9,0-5.16-4.44-5.16-4.44,4.67-1.17,3.82-4.8,2.3-8.21Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,205.14c.65-.86,1.36-1.84-.12-2.15s-10.49-.68-13.55,0-2.19,2.37-2.19,2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,407.49a2,2,0,0,1-1.49-.08.58.58,0,0,1-.14-.66.68.68,0,0,1,.36-.42c.81-.39,2.67.37,2.75.4a.14.14,0,0,1,.09.13.13.13,0,0,1-.08.13A7.27,7.27,0,0,1,422,407.49Zm-1-1a.44.44,0,0,0-.16.06.35.35,0,0,0-.22.24c-.08.25,0,.33.05.36.32.27,1.52,0,2.36-.32A4.75,4.75,0,0,0,421,406.53Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,407h-.07c-.68-.2-2.13-1.23-2.15-1.91a.48.48,0,0,1,.37-.46.82.82,0,0,1,.63.05c.8.41,1.3,2.07,1.32,2.14a.12.12,0,0,1,0,.14A.1.1,0,0,1,423.41,407Zm-1.7-2.12-.06,0c-.18.06-.17.15-.17.19,0,.4,1,1.21,1.67,1.53a3.45,3.45,0,0,0-1.09-1.68A.55.55,0,0,0,421.71,404.88Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.78,410.42c-.77,0-1.51-.1-1.76-.45a.56.56,0,0,1,0-.62.77.77,0,0,1,.45-.33c1-.27,3.1.92,3.19,1a.17.17,0,0,1,.07.15.16.16,0,0,1-.12.12A11.27,11.27,0,0,1,378.78,410.42Zm-.95-1.16a1.12,1.12,0,0,0-.27,0,.5.5,0,0,0-.28.2c-.1.18-.06.27,0,.32.28.38,1.8.39,2.91.24A6.31,6.31,0,0,0,377.83,409.26Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,410.26h0c-.73-.33-2.16-1.62-2.05-2.3,0-.16.14-.36.53-.4a1.05,1.05,0,0,1,.79.24,4.13,4.13,0,0,1,.93,2.31.16.16,0,0,1-.06.13Zm-1.46-2.43h-.08c-.26,0-.27.13-.28.16-.07.41.91,1.43,1.65,1.87a3.36,3.36,0,0,0-.79-1.85A.81.81,0,0,0,379.13,407.83Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.19 410.12 381.19 410.12 380.6 396.24 386.59 396.24 387.19 410.12",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.09 405.41 424.23 406.68 418.35 393.75 424.21 392.48 430.09 405.41",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.67,406.09l6.58-1.42a.52.52,0,0,1,.59.29l2.28,5a.88.88,0,0,1-.63,1.22c-2.31.46-3.45.57-6.35,1.2-1.78.38-5.8,1.36-8.26,1.89s-3.3-1.83-2.35-2.27c4.31-2,6.1-3.69,7.27-5.3A1.48,1.48,0,0,1,423.67,406.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.23,409.42h6.55a.52.52,0,0,1,.51.41l1.18,5.33a.87.87,0,0,1-.86,1.07c-2.36,0-5.77-.18-8.74-.18-3.47,0-6.47.19-10.54.19-2.46,0-3.14-2.49-2.11-2.72,4.69-1,8.51-1.13,12.57-3.63A2.77,2.77,0,0,1,381.23,409.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.38,212.38c-1.21,2.87-2.51,5.48-3.9,8.17s-2.89,5.28-4.56,7.85a56.71,56.71,0,0,1-5.68,7.5,26.68,26.68,0,0,1-3.78,3.5,13.47,13.47,0,0,1-5.75,2.63l-1.29.23-1.12-.53a7.23,7.23,0,0,1-2.21-1.68,7.38,7.38,0,0,1-1.28-2,11.59,11.59,0,0,1-.9-3.46,22.12,22.12,0,0,1,.24-5.65,40.47,40.47,0,0,1,1.15-5,45.64,45.64,0,0,1,1.73-4.78l4.34,1.2c-.11,1.49-.27,3.08-.33,4.61s-.12,3-.07,4.5a17.55,17.55,0,0,0,.46,3.94,3.1,3.1,0,0,0,.47,1.13c.17.17.1-.09-.21-.27l-2.41-.31a6.29,6.29,0,0,0,2-1.22,22.36,22.36,0,0,0,2.47-2.55,57.29,57.29,0,0,0,4.57-6.57c1.42-2.36,2.77-4.81,4.06-7.3s2.54-5.07,3.67-7.52Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.46,205.51c5.62,1.29,15.05,29.18,15.05,29.18l-9.18,3.06s-9.37-13.88-12.54-20.57C395.46,210.17,399.72,204.19,405.46,205.51Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.46,205.51c5.62,1.29,15.05,29.18,15.05,29.18l-9.18,3.06s-9.37-13.88-12.54-20.57C395.46,210.17,399.72,204.19,405.46,205.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,215.11c-1.5-1.79-2.49.61-2.2,5.8.91,1.61,1.95,3.36,3,5.09C404.93,220.84,404.56,217.42,403,215.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.68,236a44,44,0,0,1,9.27-2.53,1.18,1.18,0,0,1,1.23.73c.59,1.52,1.09,4.21.59,5.12-.61,1.11-9,2.72-10.1,2.06-.78-.45-1.4-2.67-1.71-4A1.2,1.2,0,0,1,410.68,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.88,205.82s-6.38,7.21-.36,51.81h32.07c.22-4.92-2.88-28.93,1.87-52.12a84.56,84.56,0,0,0-10.73-1.36,119,119,0,0,0-13.63,0A59.9,59.9,0,0,0,371.88,205.82Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.88,205.82s-6.38,7.21-.36,51.81h32.07c.22-4.92-2.88-28.93,1.87-52.12a84.56,84.56,0,0,0-10.73-1.36,119,119,0,0,0-13.63,0A59.9,59.9,0,0,0,371.88,205.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.75,221.21c-.54-3.6-3.94-2.8-6.68-1.5a147.85,147.85,0,0,0,.29,17.25C371.65,235.9,376.52,226.38,375.75,221.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.24,210.16c3.71,7.38-13.7,27.83-13.7,27.83l-6.21-10.19s5.62-9,7.92-16C370.09,203.05,376.42,204.54,379.24,210.16Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.24,210.16c3.71,7.38-13.7,27.83-13.7,27.83l-6.21-10.19s5.62-9,7.92-16C370.09,203.05,376.42,204.54,379.24,210.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,226.86c1.55,1.77,6,7,7.32,9.48a.72.72,0,0,1-.06.76c-.91,1.25-3.46,3.34-4.7,3.33s-7.67-7.14-7.58-8.47c.06-1,2.73-3.89,3.92-5.13A.75.75,0,0,1,360,226.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,221.79l.31-1.08a4.41,4.41,0,0,0-1.34-4.55l-4-3.47s-1.87,7.67,1.62,10.3Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.1,215.9l.94-.73-.1-2.11.65-1.37.75,1.71,1,2.22a2.9,2.9,0,0,1,.25,1.26l-.07,2.46Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.6 396.24 380.9 403.39 386.9 403.39 386.59 396.24 380.6 396.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.21 392.48 418.35 393.75 421.39 400.42 427.25 399.15 424.21 392.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.26,183c1.11,5.84,2.05,9.21-.1,12.9-3.25,5.55-11,4.72-13.85-.67-2.55-4.86-3.94-13.6,1.12-17.33A8.12,8.12,0,0,1,392.26,183Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,187.67c-1.85-1.85-5.55-2.46-6.13-6.59s2-6.66,6.13-7.87,12.75-2,12.33,2.21c3.08,0,4.29,3.12,2.71,6.71s-3.31,9.37-2.43,12.54c-1.74,2.58-8.53,2.45-9.53-1S381.92,188.75,380.84,187.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.33,172.23s-3.56,1.26-4.19,6.13,3.11,5.56,5.11,4.6l.29-6C375,177.21,376.33,172.23,376.33,172.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.59,171.77s-3.77-.23-6.24,4,.7,6.33,2.91,6.22l2.59-5.37C378.39,175.82,381.59,171.77,381.59,171.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,175.94s2.57-2.9,4.54-1.28A12.22,12.22,0,0,0,392.34,175.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,187.65a6.72,6.72,0,0,1-.63,4.27c-.9,1.73-2.44,1.2-3.11-.44-.6-1.47-.86-4.14.49-5.31S382.91,185.9,383.26,187.65Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.9,257.63s6.8,45.82,10.53,63c4.09,18.79,24.93,79,24.93,79l10.73-2.32s-15.34-56.41-17.67-75c-2.53-20.19-7.83-64.68-7.83-64.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.79,396.07s2,3.88,2,3.88l12.08-2.61-1-3.63Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.2,274c7.86,1.54,7,30.87,6.08,46-2.26-10.66-5.59-31.19-7.85-45.75A2.69,2.69,0,0,1,387.2,274Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.52,257.63s-.82,44.82-.17,63.1c.68,19,7.32,81.28,7.32,81.28h10.15s.38-61.15.83-79.82c.49-20.36,3-64.56,3-64.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.78,394.71h0a.1.1,0,0,0,.1-.11c-1.79-17.22-6-58.9-6.55-73.87-.54-15.3,0-49.52.12-59.65a.11.11,0,0,0-.1-.1h0a.1.1,0,0,0-.11.1c-.16,10.13-.66,44.35-.11,59.66.53,15,4.75,56.66,6.54,73.88A.11.11,0,0,0,380.78,394.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72,398c-.05,0,.57,4.22.57,4.22h12.35l.34-3.76Z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebre);
export default __webpack_public_path__ + "static/media/webre.132b946b4891b7b4b679a3180af3f030.svg";
export { ForwardRef as ReactComponent };